//RegisterPage.jsx


import React,{useState} from "react";
import {Link,useNavigate} from "react-router-dom";
import {register,resendVerification} from "../api/reportApi";

export default function RegisterPage(){
    const navigate=useNavigate();
    const [loginValue,setLoginValue]=useState("");
    const [email,setEmail]=useState("");
    const [password,setPassword]=useState("");
    const [confirmPassword,setConfirmPassword]=useState("");
    const [error,setError]=useState("");
    const [success,setSuccess]=useState("");
    const [loading,setLoading]=useState(false);
    const [resending,setResending]=useState(false);
    const [resendCooldown,setResendCooldown]=useState(0);

    React.useEffect(()=>{
        if(resendCooldown<=0)return;
        const timer=setInterval(()=>setResendCooldown(v=>v-1),1000);
        return()=>clearInterval(timer);
    },[resendCooldown]);

    const handleSubmit=async e=>{
        e.preventDefault();
        if(loading||resending)return;
        setError("");
        setSuccess("");
        if(password!==confirmPassword){
            setError("Passwords do not match");
            return;
        }
        try{
            setLoading(true);
            await register(loginValue.trim(),email.trim(),password);
            setResendCooldown(60);
            setSuccess("Registration successful. Check your email and click the verification link before logging in.");
            setPassword("");
            setConfirmPassword("");
        }catch(err){
            setError(err.message||"Registration failed");
        }finally{
            setLoading(false);
        }
    };

    const handleResend=async()=>{
        if(resending||loading||resendCooldown>0)return;
        setError("");
        setSuccess("");
        const normalizedEmail=email.trim();
        if(!normalizedEmail){
            setError("Enter your email address");
            return;
        }
        try{
            setResending(true);
            const message=await resendVerification(normalizedEmail);
            setResendCooldown(60);
            setSuccess(message||"Verification email has been sent.");
        }catch(err){
            setError(err.message||"Unable to resend verification email");
        }finally{
            setResending(false);
        }
    };

    return(
        <div className="min-h-screen flex items-center justify-center bg-black text-white px-4">
            <form onSubmit={handleSubmit} className="w-full max-w-md rounded-2xl border border-gray-700 bg-neutral-950 p-6 shadow-xl">
                <h1 className="text-2xl font-semibold mb-6">Create Custor account</h1>
                <div className="space-y-4">
                    <input type="text" placeholder="Login" value={loginValue} onChange={e=>setLoginValue(e.target.value)} disabled={loading||!!success} autoComplete="username" className="w-full rounded-xl border border-gray-700 bg-black px-4 py-3 text-white"/>
                    <input type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} disabled={loading||!!success} autoComplete="email" className="w-full rounded-xl border border-gray-700 bg-black px-4 py-3 text-white"/>
                    <input type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} disabled={loading||!!success} autoComplete="new-password" className="w-full rounded-xl border border-gray-700 bg-black px-4 py-3 text-white"/>
                    <input type="password" placeholder="Confirm password" value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)} disabled={loading||!!success} autoComplete="new-password" className="w-full rounded-xl border border-gray-700 bg-black px-4 py-3 text-white"/>
                    {error&&<div className="text-sm text-red-400">{error}</div>}
                    {success&&<div className="text-sm text-green-400">{success}</div>}
                    {!success&&(
                        <button type="submit" disabled={loading||!loginValue.trim()||!email.trim()||!password||!confirmPassword} className="w-full rounded-xl bg-red-500 py-3 font-semibold text-black disabled:opacity-50">
                            {loading?"Creating account...":"Register"}
                        </button>
                    )}
                    {success&&(
                        <>
                            <button type="button" onClick={handleResend} disabled={resending||resendCooldown>0} className="w-full rounded-xl border border-gray-700 bg-black py-3 font-semibold text-white disabled:opacity-50">
                                {resending?"Sending...":resendCooldown>0?`Resend available in ${resendCooldown}s`:"Resend verification email"}
                            </button>
                            <button type="button" onClick={()=>navigate("/login")} disabled={resending} className="w-full rounded-xl bg-red-500 py-3 font-semibold text-black disabled:opacity-50">
                                Go to login
                            </button>
                        </>
                    )}
                </div>
                <div className="mt-5 text-sm text-gray-400">
                    Already have an account?{" "}
                    <Link to="/login" className="text-red-400 hover:text-red-300">Login</Link>
                </div>
                <div className="mt-8 text-sm text-gray-500">
                    <Link to="/terms" className="hover:text-gray-300">Terms of Service</Link>{" · "}
                    <Link to="/privacy" className="hover:text-gray-300">Privacy Policy</Link>{" · "}
                    <Link to="/refund" className="hover:text-gray-300">Refund Policy</Link>
                </div>
            </form>
        </div>
    );
}